import withTag from '<components>/hoc/tag';
import Cell from './Cell';

export default withTag('th')(Cell);
